/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { svgs } from 'assets';
import PageContainer from 'components/common/PageContainer';
import jwt from 'jsonwebtoken';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { respondToWaiver } from 'redux/actions/onboarding';
import { useToast } from 'context/toastContext';
import { FormContainer, Wrapper } from '../styles';

const DeclineWaiver = () => {
  const dispatch = useDispatch();
  const { token } = useParams();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const declineWaiver = async () => {
    setLoading(true);
    const { candidate_id } = jwt.decode(token);
    const result = await dispatch(respondToWaiver('REJECTED', candidate_id, toast));
    setSuccess(() => result);
    setLoading(false);
  };

  useEffect(() => {
    declineWaiver();
  }, [token]);

  return (
    <PageContainer>
      <FormContainer>
        <div className="logo-wrapper">
          <svgs.COLOURED_LOGO />
        </div>
        <Wrapper>
          <div className="content status-wrapper">
            {loading
              ? (
                <>
                  <p className="header">Loading...</p>
                </>
              )
              : success ? (
                <>
                  <div className="logo-wrapper">
                    <img src={svgs.DELETE_WARN} alt="delete-warn" />
                  </div>
                  <p className="header">Employee waiver request declined successfully</p>

                </>
              ) : (<> </>)}
          </div>
        </Wrapper>
      </FormContainer>
    </PageContainer>
  );
};

export default DeclineWaiver;
